import "./LuogoPage.css";
import { t } from "../../services/formatters";
import { useLuogoPage } from "./useLuogoPage";
import { TextInput } from "../../components/TextInput";
import { Button } from "../../components/Button";
import { ErrorModal } from "../../components/ErrorModal";
import { useEditAppointment } from "../../hooks/useEditAppointment";
import { EditAppointmentModal } from "../../components/EditAppointmentModal";
import { Suggestions } from "../../components/Suggestions";

export const LuogoPage = () => {
    const {
        next,
        onLuogoChange,
        onLuogoBlur,
        onSuggestionClick,
        suggestions,
        read,
        update,
        onGeoClick,
        isFetchFilialiStart,
        isFetchFilialiWaiting,
        isFetchPositioEnd,
        getSearchInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        askForEditAppointment,
        isLoading,
        setPrestitoBusiness,
        setC5,
        redirectTo,
    } = useLuogoPage();

    const redirect = read("redirect");
    if (redirect && redirect != "") {
        redirectTo(redirect);
    }

    return (
        <>
            {isLoading && <div id="start-overlay">Attendere...</div>}

            {!isLoading && (
                <div id="luogo-page">
                    <div className={`section page-title-component center-on-tablet`}>
                        <h1 dangerouslySetInnerHTML={{ __html: t("fissa_qui") }}></h1>
                        <div>{t("basta_un_giorno")}</div>
                    </div>

                    <div className={`section white-box input-box-component`}>
                        <h2>{t("dove_appuntamento")}</h2>
                        <p className={`input-box-subtitle`}>&nbsp;</p>
                        <TextInput
                            isGeo={true}
                            name="cap"
                            placeholder={t("inserisci_cap")}
                            value={read("luogo")}
                            onChange={onLuogoChange}
                            onBlur={onLuogoBlur}
                            onIconClick={onGeoClick}
                            state={getSearchInputState()}
                            onEnter={() => {
                                onSuggestionClick();
                            }}></TextInput>
                        <Suggestions suggestions={suggestions} onSuggestionClick={onSuggestionClick} />
                        {/*suggestions.length > 0 && (
              <div id="searchSuggestions">
                <ul>
                  {suggestions.map((itm, idx) => (
                    <li
                      onClick={() => {
                        onSuggestionClick(itm);
                      }}
                      className="clickable"
                      key={idx}>
                      {getSuggestionText(itm)}
                    </li>
                  ))}
                </ul>
              </div>
            )*/}

                        {isFetchPositioEnd() ? <small style={{ color: "#5DBFAB" }}>Ottimo! Abbiamo trovato una filiale vicino a te!</small> : ""}
                    </div>

                    <div className={`section white-box`}>
                        <label htmlFor="solo-info">
                            <input
                                onChange={(evt) => {
                                    // setSoloInfo(evt.target.checked ? "si" : "no");
                                    update("solo_info", evt.target.checked ? "si" : "no");
                                }}
                                type="checkbox"
                                name="solo-info"
                                id="solo-info"
                            />
                            {t("solo_info")}
                        </label>
                    </div>

                    <div className="section text-center">
                        <Button
                            id="go-to-select-state-btn"
                            disabled={!isFetchFilialiStart()}
                            onClick={next}
                            classList="btn-responsive always-style"
                            loading={isFetchFilialiWaiting()}
                            text={t("avanti")}
                        />
                    </div>

                    <div className="external-products-footer-component">
                        <p id="or-text" className="text-center">
                            {t("oppure")}
                        </p>

                        <div className="section flex-row centered-content text-center">
                            <h4 className="flex-cell clickable">
                                <a
                                    onClick={setC5}
                                    className="hide-tablet hide-desktop"
                                    aria-roledescription="link"
                                    aria-label={t("cessione_quinto")}
                                    dangerouslySetInnerHTML={{ __html: t("cessione_quinto") }}></a>
                                <a
                                    onClick={setC5}
                                    className="hide-mobile"
                                    aria-roledescription="link"
                                    aria-label={t("cessione_quinto")}
                                    dangerouslySetInnerHTML={{ __html: t("cessione_quinto_tablet") }}></a>
                            </h4>
                            <h4 className="flex-cell clickable">
                                <a
                                    onClick={setPrestitoBusiness}
                                    className="hide-tablet hide-desktop"
                                    aria-roledescription="link"
                                    aria-label={t("finanziamento_business")}
                                    dangerouslySetInnerHTML={{ __html: t("finanziamento_business") }}></a>
                                <a
                                    onClick={setPrestitoBusiness}
                                    className="hide-mobile"
                                    aria-roledescription="link"
                                    aria-label={t("finanziamento_business")}
                                    dangerouslySetInnerHTML={{
                                        __html: t("finanziamento_business_tablet"),
                                    }}></a>
                            </h4>
                        </div>

                        {/* Edit appto link */}
                        <div className="section text-center bottom-area">
                            <div className={`section edit-appointment-link-component text-uppercase color-text-primary clickable`} onClick={askForEditAppointment}>
                                {t("modifica_appuntamento_gia_fissato")}
                            </div>
                        </div>
                    </div>

                    <ErrorModal
                        open={fetchError}
                        text={fetchErrorMessage}
                        onCloseModal={() => {
                            setFetchError(false);
                        }}></ErrorModal>

                    <EditAppointmentModal
                        open={showModal}
                        title={t("modifica_appuntamento")}
                        text={read("codiceFiscale") ? t("modifica_appuntamento_esistente") : t("modifica_appuntamento_esistente_unknown")}
                        onCloseModal={closeModal}></EditAppointmentModal>
                </div>
            )}
        </>
    );
};
